"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlayerEvent;
(function (PlayerEvent) {
    PlayerEvent["PLAY"] = "PLAY";
    PlayerEvent["PAUSE"] = "PAUSE";
    PlayerEvent["SET_PLAYER_TIME"] = "SET_PLAYER_TIME";
    PlayerEvent["ADD_CUE"] = "ADD_CUE";
    PlayerEvent["REMOVE_CUE"] = "REMOVE_CUE";
})(PlayerEvent || (PlayerEvent = {}));
class PlayerMessageDispatcher {
    constructor() {
        this.iframe = null;
    }
    sendMessage(message) {
        var _a, _b, _c;
        try {
            (_c = (_b = (_a = this.iframe) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage) === null || _c === void 0 ? void 0 : _c.call(_b, JSON.stringify(message), '*');
        }
        catch (_d) { }
    }
    play() {
        this.sendMessage({ event: PlayerEvent.PLAY });
    }
    pause() {
        this.sendMessage({ event: PlayerEvent.PAUSE });
    }
    setTime(seconds) {
        this.sendMessage({
            event: PlayerEvent.SET_PLAYER_TIME,
            payload: seconds
        });
    }
    addCue(cue) {
        this.sendMessage({ event: PlayerEvent.ADD_CUE, payload: cue });
    }
    removeCue(cue) {
        this.sendMessage({ event: PlayerEvent.REMOVE_CUE, payload: cue });
    }
}
exports.default = PlayerMessageDispatcher;
